"use client";

import { CountryInfo } from "@/store/types/countryTypes";
import React from "react";

const CountryEntryRequirements: React.FC<{ country: CountryInfo }> = ({ country }) => {
  const sectionData = country?.entryRequirements;
  const tableRows = sectionData?.requirementsTable || [];

  if (tableRows.length === 0) {
    return null;
  }

  const heading = sectionData?.heading || "University Entry Requirements";
  const subheading =
    sectionData?.subheading ||
    `Review the minimum academic and English language qualifications most ${country.countryName} universities ask for.`;

  return (
    <div className="w-full my-12 space-y-6">
      <div>
        <h2 className="text-2xl sm:text-3xl font-bold text-[#1C2233] ff_poppins">
          {heading}
        </h2>
        {subheading && (
          <p className="mt-1.5 text-xs sm:text-sm text-[#667085] ff_poppins">
            {subheading}
          </p>
        )}
      </div>

      {/* TABLE */}
      <div className="rounded-[18px] overflow-hidden border border-[#E0D8FF] bg-white shadow-sm">
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-[#0A1629] text-white uppercase text-xs sm:text-sm font-semibold tracking-wider">
                <th className="py-4 px-6">Level of Education</th>
                <th className="py-4 px-6">Min. Qualification Required</th>
                <th className="py-4 px-6">English Test — Min. Required</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100 text-xs sm:text-sm text-[#333E5C] ff_poppins font-medium">
              {tableRows.map((row, index) => (
                <tr
                  key={index}
                  className={index % 2 === 0 ? "bg-white" : "bg-[#FBF9FF]"}
                >
                  <td className="py-4 px-6 font-semibold text-[#1C2233]">
                    {row.levelOfEducation}
                  </td>
                  <td className="py-4 px-6 text-[#525B73]">
                    {row.minQualification}
                  </td>
                  <td className="py-4 px-6 font-bold text-[#0A1629]">
                    {row.englishRequirement}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CountryEntryRequirements;

